import React, { useState } from 'react';
import { LockIcon, MailIcon, LogInIcon } from 'lucide-react';
export function VendorLogin({
  onLogin
}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = e => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    // Simulate authentication
    setTimeout(() => {
      // For demo purposes, any login works
      const vendor = {
        id: 'V-2023-001',
        name: 'Acme Supplies Ltd',
        email: email,
        contactName: 'John Smith',
        phone: '(555) 123-4567',
        status: 'Active'
      };
      setIsLoading(false);
      onLogin(vendor);
    }, 1000);
  };
  const handleSocialLogin = provider => {
    setIsLoading(true);
    // Simulate authentication with social provider
    setTimeout(() => {
      const vendor = {
        id: 'V-2023-001',
        name: 'Acme Supplies Ltd',
        email: provider === 'google' ? 'vendor@gmail.com' : 'vendor@outlook.com',
        contactName: 'John Smith',
        phone: '(555) 123-4567',
        status: 'Active'
      };
      setIsLoading(false);
      onLogin(vendor);
    }, 1000);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center" data-id="element-2">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6TfLnmLX2evxxxZK6TYFtj/Rapid_P2P_-_Blue-Green.svg" alt="RapidP2P Logo" className="mx-auto h-16" data-id="element-4" />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-5">
          Vendor Portal
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-6">
          Sign in to your vendor account
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-7">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-8">
          {/* Social Login Buttons */}
          <div className="space-y-3 mb-6" data-id="element-9">
            <button type="button" onClick={() => handleSocialLogin('microsoft')} disabled={isLoading} className="w-full flex justify-center items-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-10">
              <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-11">
                <path d="M11.4 2H2V11.4H11.4V2Z" fill="#F25022" data-id="element-12" />
                <path d="M11.4 12.6H2V22H11.4V12.6Z" fill="#00A4EF" data-id="element-13" />
                <path d="M22 2H12.6V11.4H22V2Z" fill="#7FBA00" data-id="element-14" />
                <path d="M22 12.6H12.6V22H22V12.6Z" fill="#FFB900" data-id="element-15" />
              </svg>
              Continue with Microsoft
            </button>
            <button type="button" onClick={() => handleSocialLogin('google')} disabled={isLoading} className="w-full flex justify-center items-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-16">
              <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-17">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-18" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-19" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-20" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-21" />
              </svg>
              Continue with Google
            </button>
          </div>
          <div className="relative my-6" data-id="element-22">
            <div className="absolute inset-0 flex items-center" data-id="element-23">
              <div className="w-full border-t border-gray-300" data-id="element-24"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-25">
              <span className="px-2 bg-white text-gray-500" data-id="element-26">
                Or continue with
              </span>
            </div>
          </div>
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-27">
            {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded" data-id="element-28">
                {error}
              </div>}
            <div data-id="element-29">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-30">
                Email address
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-31">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-32">
                  <MailIcon className="h-5 w-5 text-gray-400" data-id="element-33" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" placeholder="vendor@company.com" data-id="element-34" />
              </div>
            </div>
            <div data-id="element-35">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-36">
                Password
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-37">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-38">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-39" />
                </div>
                <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-40" />
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-41">
              <div className="flex items-center" data-id="element-42">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" data-id="element-43" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-44">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-45">
                <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500" data-id="element-46">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-47">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-48">
                {isLoading ? 'Signing in...' : <>
                    <LogInIcon className="h-4 w-4 mr-2" data-id="element-49" />
                    Sign in with Email
                  </>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
}